import { ACCESS_SCOPE_HEADER, type AccessScope } from "./types/accessControl";

export type ApiHeaders = Record<string, string>;

/**
 * The headers every request to our API carries: the login token, and the app scope the backend
 * applies its lock and allow/block rules to. Without the scope it falls back to the main app's
 * rules, so a single-module app's user would get 403 from a main app they may not use.
 *
 * A plain function for the auth provider, which can't use useApiHeaders (that hook reads its
 * context); everything else goes through useApi or useApiHeaders.
 */
export const buildApiHeaders = (jwtToken: string | null | undefined, scope: AccessScope): ApiHeaders => ({
  [ACCESS_SCOPE_HEADER]: scope,
  ...(jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {}),
});
